import { useEffect, useState } from 'react';
import { Users, UserPlus, Image as ImgIcon } from 'lucide-react';
import FollowersModal from './FollowersModal';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

/** Facebook-style stats strip shown on a vendor profile, right under the bio.
 *  Pulls from /api/social/users/{user_id}/social.
 *  Tap Followers / Following to open a list modal. */
export default function VendorSocialStrip({ userId, viewerId }) {
  const [stats, setStats] = useState(null);
  const [modalTab, setModalTab] = useState(null); // 'followers' | 'following' | null

  useEffect(() => {
    if (!userId) return;
    let cancel = false;
    (async () => {
      try {
        const headers = viewerId ? { Authorization: `Bearer ${localStorage.getItem('token')}` } : {};
        const res = await fetch(`${API}/social/users/${userId}/social`, { headers });
        if (res.ok && !cancel) setStats(await res.json());
      } catch {}
    })();
    return () => { cancel = true; };
  }, [userId, viewerId]);

  if (!stats) return null;

  const Item = ({ icon: Icon, value, label, testid, onClick, clickable }) => {
    const Tag = clickable ? 'button' : 'div';
    return (
      <Tag
        type={clickable ? 'button' : undefined}
        onClick={onClick}
        className={`flex items-center gap-2 px-4 py-2.5 ${clickable ? 'hover:bg-white/5 active:bg-white/10 transition-colors cursor-pointer' : ''}`}
        data-testid={testid}
      >
        <Icon size={14} className="text-[#A78BFA]" />
        <span className="text-white text-base font-bold">{value}</span>
        <span className="text-zinc-400 text-xs uppercase tracking-wider">{label}</span>
      </Tag>
    );
  };

  return (
    <>
      <div
        className="mt-4 inline-flex flex-wrap items-center bg-[#13153A]/80 border border-white/5 rounded-2xl divide-x divide-white/10 backdrop-blur-md shadow-[0_8px_30px_-10px_rgba(168,85,247,0.3)] overflow-hidden"
        data-testid="vendor-social-strip"
      >
        <Item
          icon={Users}
          value={stats.followers_count}
          label="Followers"
          testid="vsstrip-followers"
          clickable
          onClick={() => setModalTab('followers')}
        />
        <Item
          icon={UserPlus}
          value={stats.following_count}
          label="Following"
          testid="vsstrip-following"
          clickable
          onClick={() => setModalTab('following')}
        />
        <Item icon={ImgIcon} value={stats.posts_count} label="Posts" testid="vsstrip-posts" />
      </div>

      <FollowersModal
        open={modalTab !== null}
        onClose={() => setModalTab(null)}
        userId={userId}
        initialTab={modalTab || 'followers'}
        followersCount={stats.followers_count}
        followingCount={stats.following_count}
      />
    </>
  );
}
